import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { SimpleHeader, SimpleFooter, DoneSection } from '@lana-ui/arc'
import { Spinner, Toast } from '@lana-ui/common'
import config from '../../lib/lib.config'
import useFetch from '../../components/common/helpers/useFetch'
import { NewslettersForm } from './components/NewslettersForm'
import classNames from 'classnames'

const ServiciosAlertados = () => {
  const { guid } = useParams()
  const [selectedOptions, setSelectedOptions] = useState([])
  const [newsletters, setNewsletters] = useState([])
  const [hasSubmitted, setHasSubmitted] = useState(false)
  const [showToast, setShowToast] = useState(false)
  const urlSuscripcionAlerta = `${config.newsletterApi}/SuscripcionAlerta/${guid}`

  const addOption = option => setSelectedOptions(prev => [...prev, option])
  const removeOption = option => setSelectedOptions(prev => prev.filter(id => option !== id))
  const toggleSelectAll = newsletters => {
    selectedOptions.length === newsletters.length ? setSelectedOptions([]) : setSelectedOptions(newsletters.map(({ id }) => id))
  }
  const allSelected = selectedOptions.length === newsletters.length && newsletters.every(newsletter => selectedOptions.includes(newsletter.id))

  const handleOptionChange = (e, { id }) => {
    e.target.checked ? addOption(id) : removeOption(id)
  }

  const handleSubmit = async e => {
    e.preventDefault()
    try {
      const response = await executeFetch(urlSuscripcionAlerta, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(selectedOptions),
      })

      if (response) {
        setHasSubmitted(true)
      }
    } catch (error) {
      setShowToast(true)
      console.error('Error submitting data:', error)
    }
  }

  const [{ data, loading, error }, executeFetch] = useFetch(urlSuscripcionAlerta, {
    method: 'GET'
  })

  const classes = classNames('container mx-auto flex flex-column flex-grow-1 px-16 px-24_md px-32_lg max-w-600', { 'jc-center': loading })
  useEffect(() => {
    if (error) setShowToast(true);
    else setShowToast(false); // Si se recarga la página y ya no hay error, evita que vuelva a mostrarse el toast
  }, [error])

  useEffect(() => {
    if (data) {
      setNewsletters(data.servicios || [])
    }
  }, [loading, data])

  const handleAddMoreSuscriptions = () => {
    window.location.reload()
  }

  const renderContent = () => {
    if (hasSubmitted) return <DoneSection allSelected={allSelected} handleAddMoreSuscriptions={handleAddMoreSuscriptions} />

    return(
      <NewslettersForm
        newsletters={newsletters}
        selectedOptions={selectedOptions}
        toggleSelectAll={toggleSelectAll}
        handleOptionChange={handleOptionChange}
        handleSubmit={handleSubmit}
      />
)  }

  return (
    <>
      <div className='flex flex-column gap-32 min-h-100vh'>
        <SimpleHeader />
        <main className={classes}>
          {loading ? (
            <Spinner color='006998' logoName='ln' logoSize='xxl' />
          ) : (
            renderContent()
          )}
        </main>
        <SimpleFooter />
      </div>
      <Toast status='warning' title="¡Uppps!" closeAuto={3000} positionFloat='right' value={showToast} changeValue={setShowToast}>
        Parece que hubo un problema Volvé a intentarlo más tarde.
      </Toast>
    </>
  )
}

export default ServiciosAlertados

